import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import { apiGet } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';

export const useApplications = (params) =>
  useQuery({
    queryKey: ['applications', params],
    queryFn: () =>
      apiGet('/landlords/application_management/applications', params).then((response) => {
        return response.applications;
      }),
    onError: () => message.error(getTranslatedString('unknownError')),
  });

export const useApplicationsStats = (statParams) =>
  useQuery({
    queryKey: ['applications', statParams],
    queryFn: () =>
      apiGet('/landlords/application_management/applications/stats', statParams).then(
        (response) => {
          return response.stats;
        }
      ),
    onError: () => message.error(getTranslatedString('unknownError')),
  });

export const useApplicationProperties = () =>
  useQuery({
    queryKey: ['sites_and_properties'],
    queryFn: () =>
      apiGet('/landlords/application_management/applications/sites_and_properties').then(
        (response) => {
          return response.sites;
        }
      ),
    onError: () => message.error(getTranslatedString('unknownError')),
  });

export const useApplicationAgents = () =>
  useQuery({
    queryKey: ['agents'],
    queryFn: () =>
      apiGet('/landlords/agents').then((response) => {
        return response;
      }),
    onError: () => message.error(getTranslatedString('unknownError')),
  });
